import PremiumIcon from '@atlaskit/icon/core/premium';
import React from 'react';

export const SvgSparkle = () => (
  <PremiumIcon label="" testId="ads-refreshed-icon" />
);
